import account from './account/ru-RU.json';
import affiliate from './affiliate/ru-RU.json';
import component from './component/ru-RU.json';
import menus from './menus/ru-RU.json';
import user from './users/ru-RU.json';
import global from './global/ru-RU.json';
import support from './support/ru-RU.json';
import result from './result/ru-RU.json';
import finance from './finance/ru-RU.json';
import region from './region/ru-RU.json';
import request from './request/ru-RU.json';
// 因不知名原因，当存在menu和user文件夹时，i18n-ally插件没反应，故修改文件名为menus,users

const titleMenu = Object.entries(menus).reduce((pre: object, [key, value]: [string, string]) => {
  // 添加统一后缀
  return {
    ...pre,
    [`title.${key}`]: `${value} - LightNode`,
  };
}, {});

export default {
  ...account,
  ...affiliate,
  ...component,
  ...menus,
  ...titleMenu,
  ...user,
  ...global,
  ...support,
  ...result,
  ...finance,
  ...region,
  ...request,
};
